export default __webpack_public_path__ + "static/media/323D.4ddd37d1.pdf";